import initFilterAccordion from './filter-accordion';
import getFilterableContent from './fetch';
import { setParams, getParams } from './params.js';
import setInputs from './inputs';
import { clearFilters } from './active-filters.js';

/**
 * Initiate filterable content blocks logic.
 */
const initFilterableContent = () => {
	initFilterAccordion();

	// Get all filterable content blocks.
	const filterableContentBlock = document.querySelectorAll('.em-filterable-content');

	// Loop through each block and apply logic only to that block.
	filterableContentBlock.forEach((block) => {
		const contentContainer = block.querySelector('.em-filterable-content__listings');
		const filterContainer = block.querySelector('.em-filterable-content__filter-container');
		const inputs = block.querySelectorAll('input, select');
		const searchButton = block.querySelector('.search');

		// Process filters and search values.
		const getFilteredContent = () => {
			filterContainer.dataset.paged = 1;
			setParams(block);
			const params = getParams(block);
			getFilterableContent(contentContainer, params);
		};

		// Loop through inputs and set event handlers.
		inputs.forEach((input) => {
			if (input.type === 'checkbox' || input.tagName === 'SELECT') {
				input.addEventListener('change', () => {
					getFilteredContent();
				});
			} else {
				input.addEventListener('keyup', (e) => {
					if (e.code === 'Enter') {
						getFilteredContent();
					}
				});
			}
		});

		// If search input not empty submit search.
		searchButton.addEventListener('click', (e) => {
			const button = e.target.closest('button');
			if (button.previousElementSibling.value) {
				getFilteredContent();
			}
		});

		// Set exisitng values from query string.
		setInputs(block);

		// Get parameters.
		const params = getParams(block);

		// If pagination type is load more reset page to 1 on refresh.
		if (params.pagination === 'load_more') {
			filterContainer.setAttribute('data-page', 1);
		}

		// Get initial list of posts and output.
		getFilterableContent(contentContainer, params);

		// Initiate clear filters button..
		clearFilters(block, inputs, getFilterableContent);

		window.addEventListener('popstate', () => {
			// Set exisitng values from query string.
			setInputs(block);
			getFilterableContent(contentContainer, getParams(block));
		}, false);
	});
};

initFilterableContent();
